import { isOpenOrder } from '@src/domains/orders/core/isOpenOrder';
import type { Order } from '@src/domains/orders/types/order';

/** The order the buyer already opened from this direct link, as long as it is still open. */
export const findDirectLinkOrder = (orders: Order[], linkCode: string): Order | undefined =>
  orders.find((order) => isOpenOrder(order) && order.directLink?.code === linkCode);
